(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grid-product"] && !Shopify.designMode) return;
  try {
    class GridProduct extends HTMLElement {
    connectedCallback() {
      if (this.swiper) return;

      this.variantSelectorButtonEls = this.querySelectorAll('.variant-selector-button');

      this.linkEls = this.querySelectorAll('.grid-product-link');
      this.variantTitleEl = this.querySelector('.grid-product-variant-title');
      this.priceEl = this.querySelector('.grid-product-price');
      this.ctaEl = this.querySelector('.grid-product-cta');
      this.rxEl = this.querySelector('.grid-product-rx');

      const isNested = this.parentElement.closest('.swiper') !== null;

      this.swiper = new window.sunski.Swiper(this.querySelector('.swiper'), {
        loop: true,
        nested: isNested,
        allowTouchMove: !isNested,
        lazy: {
          loadOnTransitionStart: true,
        },
        breakpoints: {
          1000: {
            allowTouchMove: false,
            preventClicks: false,
          }
        },
        on: {
          slideChangeTransitionStart: () => {
            this.variantSelectorButtonEls.forEach((buttonEl, index) => {
              if (index == this.swiper.realIndex) {
                buttonEl.ariaChecked = true;
                if (this.ctaEl !== null) this.ctaEl.disabled = buttonEl.dataset.unavailable === 'true';
                if (this.rxEl !== null) {
                  this.rxEl.hidden = buttonEl.dataset.rxUrl === undefined;
                  if (buttonEl.dataset.rxUrl !== undefined) this.rxEl.href = buttonEl.dataset.rxUrl;
                }
                this.linkEls.forEach(linkEl => { linkEl.href = buttonEl.dataset.variantUrl; });
                if (this.variantTitleEl !== null) this.variantTitleEl.textContent = buttonEl.dataset.variantTitle;
                window.sunski.setPrice(this.priceEl,buttonEl.dataset.price,buttonEl.dataset.compareAtPrice);
              } else {
                buttonEl.ariaChecked = false;
              }
            });
          },
          slideNextTransitionStart: () => {
            const trackCategory = this.dataset.gridProductTrack;
            const trackLabel = this.dataset.gridProductTrackLabel;
            if (trackCategory !== undefined && trackLabel !== undefined) {
              gtag('event','grid_product_variant_next',{event_category:trackCategory,event_label:trackLabel});
            }
          },
          slidePrevTransitionStart: () => {
            const trackCategory = this.dataset.gridProductTrack;
            const trackLabel = this.dataset.gridProductTrackLabel;
            if (trackCategory !== undefined && trackLabel !== undefined) {
              gtag('event','grid_product_variant_prev',{event_category:trackCategory,event_label:trackLabel});
            }
          },
        },
      });

      this.eventController = new AbortController();

      this.variantSelectorButtonEls.forEach((clickEl, clickIndex) => {
        clickEl.addEventListener('click', e => {
          this.swiper.slideToLoop(clickIndex);
        }, {signal: this.eventController.signal});
      });

      if (this.ctaEl !== null) {
        this.ctaEl.addEventListener('click',e => {
          const cart = document.querySelector('.cart').cart;
          cart.addToCart(this.variantSelectorButtonEls[this.swiper.realIndex].dataset.variantId);
        }, {signal: this.eventController.signal});
      }
    }

    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected || !this.swiper) return;
        this.eventController.abort();
        this.swiper.destroy(true, true);
        this.swiper = null;
      });
    }
  }

  customElements.define('sk-grid-product', GridProduct);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lightbox"] && !Shopify.designMode) return;
  try {
    class Lightbox extends HTMLElement {
    connectedCallback() {
      this.eventController = new AbortController();

      this.dialogEl = this.querySelector('.lightbox-dialog');
      this.swiperEl = this.querySelector('.lightbox-swiper');

      document.querySelectorAll('.lightbox-open').forEach(openEl => {
        openEl.addEventListener('click',e => { this.open(openEl); }, {signal: this.eventController.signal});
      });

      document.querySelectorAll('.lightbox-close').forEach(closeEl => {
        closeEl.addEventListener('click',e => { this.close(); }, {signal: this.eventController.signal});
      });

      this.dialogEl.addEventListener('click',e => {
        if (e.target === this.dialogEl) this.close();
      }, {signal: this.eventController.signal});

      this.dialogEl.addEventListener('cancel',e => {
        e.preventDefault();
        this.close();
      }, {signal: this.eventController.signal});
    }

    disconnectedCallback() {
      this.eventController.abort();
    }

    animating() {
      return this.dialogEl.getAnimations().length > 0;
    }

    open(openEl) {
      if (this.dialogEl.open || this.animating()) return;
      const sourceMedia = openEl.closest('.lightbox-source-media');
      if (sourceMedia === null) return;
      if (sourceMedia.swiper !== undefined && openEl.dataset.lightboxCurrentSlide === 'true') {
        const sourceSlide = openEl.closest('.swiper-slide');
        if (sourceMedia.swiper.animating || !sourceSlide.classList.contains('swiper-slide-active')) return;
      }
      this.sourceMedia = sourceMedia;

      this.style.removeProperty('display');

      const sourceEls = [...sourceMedia.querySelectorAll('.lightbox-source-picture, .lightbox-source-video-preview, .lightbox-source-video')];
      const slideIndex = el => el.closest('[data-swiper-slide-index]')?.dataset.swiperSlideIndex ?? 0;
      sourceEls.sort((a,b) => slideIndex(a) - slideIndex(b));

      const slideEls = [];
      let initialSlide = 0;
      sourceEls.forEach(sourceEl => {
        if (!sourceEl.classList.contains('lightbox-source-video')) {
          const slideEl = document.createElement('div');
          slideEl.className = 'lightbox-slide swiper-slide';
          slideEl.innerHTML = '<div class="anim-loading" aria-hidden="true"></div>';
          const img = sourceEl.querySelector('img');
          slideEl.style.setProperty('--ratio', img.getAttribute('width') / img.getAttribute('height'));
          if (openEl.contains(sourceEl)) initialSlide = slideEls.length;
          slideEls.push(slideEl);
        }
        const mediaEl = sourceEl.cloneNode(true);
        mediaEl.removeAttribute('class');
        mediaEl.querySelectorAll('[class]').forEach(el => el.removeAttribute('class'));
        mediaEl.querySelectorAll('source[srcset]').forEach(el => el.sizes = el.media ? '1054px' : '408px');
        mediaEl.querySelectorAll('img').forEach(el => el.loading = 'lazy');
        if (sourceEl.tagName === 'VIDEO') {
          mediaEl.sourceVideo = sourceEl;
          mediaEl.preload = 'none';
        }
        slideEls.at(-1).append(mediaEl);
      });

      this.swiperEl.swiper?.destroy();
      this.swiperEl.querySelector('.swiper-wrapper').replaceChildren(...slideEls);

      new window.sunski.Swiper(this.swiperEl, {
        loop: true,
        initialSlide,
        spaceBetween: 16,
        lazyPreloaderClass: 'anim-loading',
        breakpoints: {
          1000: {
            allowTouchMove: false,
          }
        },
        lazy: {
          loadOnTransitionStart: true,
        },
        navigation: {
          prevEl: this.querySelector('.lightbox-control.prev'),
          nextEl: this.querySelector('.lightbox-control.next'),
        },
        pagination: {
          el: this.querySelector('.lightbox-pagination'),
          clickable: true,
        },
        on: {
          init: (swiper) => { this.playActiveVideo(swiper); },
          slideChange: (swiper) => {
            if (!this.dialogEl.open) return;
            this.playActiveVideo(swiper);
            this.sourceMedia.swiper?.slideToLoop(swiper.realIndex, swiper.params.speed);
          },
          slideNextTransitionStart: (swiper) => {
            const track = this.dataset.lightboxTrack;
            if (track !== undefined) gtag('event','lightbox_next',{event_category:track});
          },
          slidePrevTransitionStart: (swiper) => {
            const track = this.dataset.lightboxTrack;
            if (track !== undefined) gtag('event','lightbox_prev',{event_category:track});
          },
        },
      });

      this.openEl = openEl;
      openEl.blur();
      this.dialogEl.showModal();
      this.dialogEl.focus();
    }

    playActiveVideo(swiper) {
      swiper.slides.forEach(slideEl => slideEl.querySelector('video')?.pause());
      const video = swiper.slides[swiper.activeIndex]?.querySelector('video');
      if (video && !window.sunski.prefersReducedMotion.matches) {
        video.currentTime = video.sourceVideo.currentTime;
        video.play();
      }
    }

    close() {
      if (!this.dialogEl.open || this.animating()) return;
      this.dialogEl.close();

      const realIndex = this.swiperEl.swiper.realIndex;
      const sourceSlide = this.sourceMedia.swiper?.slides.find((slideEl, index) => Number(slideEl.dataset.swiperSlideIndex ?? index) === realIndex);
      const returnEl = sourceSlide?.querySelector('.lightbox-open') ?? this.openEl;
      returnEl.focus({preventScroll: true});

      Promise.allSettled(this.dialogEl.getAnimations().map(animation => animation.finished)).then(() => {
        this.swiperEl.swiper.destroy();
        this.swiperEl.querySelector('.swiper-wrapper').replaceChildren();
        this.sourceMedia = null;
        this.openEl = null;
      });
    }
  }

  customElements.define('sk-lightbox', Lightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-slider"] && !Shopify.designMode) return;
  try {
    class ProductSlider extends HTMLElement {
    connectedCallback() {
      const slides = this.querySelectorAll('.product-slide');
      const loop = slides.length > 0 && slides.length >= 2 * Math.ceil(this.clientWidth / slides[0].offsetWidth);
      this.swiper = new window.sunski.Swiper(this, {
        loop,
        rewind: !loop,
        slidesPerView: 'auto',
        slidesOffsetBefore: this.offsetBefore() ?? 16,
        spaceBetween: 8,
        navigation: {
          prevEl: this.querySelector('.product-slider-prev'),
          nextEl: this.querySelector('.product-slider-next'),
        },
        pagination: {
          el: this.querySelector('.product-slider-pagination'),
          clickable: true,
        },
        breakpoints: {
          1000: {
            slidesOffsetBefore: this.offsetBefore() ?? 24,
            spaceBetween: 16,
            centerInsufficientSlides: true,
          },
        },
        on: {
          afterInit: swiper => this.align(swiper),
          breakpoint: swiper => this.align(swiper),
          resize: swiper => this.align(swiper),
        },
      });
    }

    disconnectedCallback() {
      this.swiper.destroy(true, true);
    }

    offsetBefore() {
      const value = window.getComputedStyle(this).getPropertyValue('--product-slider-offset').trim();
      return value.endsWith('px') ? parseFloat(value) : null;
    }

    align(swiper) {
      const offset = this.offsetBefore();
      if (offset === null || offset === swiper.params.slidesOffsetBefore) return;
      swiper.params.slidesOffsetBefore = offset;
      swiper.update();
    }
  }

  customElements.define('sk-product-slider', ProductSlider);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["secret-deal"] && !Shopify.designMode) return;
  try {
    class SecretDeal extends HTMLElement {
    connectedCallback() {
      this.eventController = new AbortController();
      const dialogEl = this.querySelector('.secret-deal-dialog');
      const containerEl = this.querySelector('.secret-deal-container');
      const codeEl = this.querySelector('.secret-deal-code');
      const copyEl = this.querySelector('.secret-deal-copy-button');
      const closeEls = this.querySelectorAll('.secret-deal-close');

      if (window.sunski.getCookie('welcome_data') !== 'SECRETDEAL') return;
      window.sunski.setCookie('welcome_data','SECRETDEAL1');

      fetch('/discount/' + codeEl.textContent.trim());

      containerEl.addEventListener('click',e => {
        e.stopPropagation();
      }, {signal: this.eventController.signal});

      copyEl.addEventListener('click',e => {
        navigator.clipboard.writeText(codeEl.textContent.trim());
        copyEl.textContent = 'Copied!';
      }, {signal: this.eventController.signal});

      closeEls.forEach(closeEl => {
        closeEl.addEventListener('click',e => {
          dialogEl.close();
        }, {signal: this.eventController.signal});
      });

      dialogEl.showModal();
    }

    disconnectedCallback() {
      this.eventController.abort();
    }
  }

  customElements.define('sk-secret-deal', SecretDeal);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["storyproof"] && !Shopify.designMode) return;
  try {
    class Storyproof extends HTMLElement {
    connectedCallback() {
      const slideCount = this.querySelectorAll('.storyproof-slide').length;
      this.swiper = new window.sunski.Swiper(this.querySelector('.storyproof-swiper'), {
        loop: slideCount >= 4,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 12,
        watchSlidesProgress: true,
        lazyPreloaderClass: 'anim-loading',
        navigation: {
          prevEl: this.querySelector('.storyproof-control.prev'),
          nextEl: this.querySelector('.storyproof-control.next'),
        },
        pagination: {
          el: this.querySelector('.storyproof-pagination'),
          clickable: true,
        },
        breakpoints: {
          1000: {
            loop: slideCount >= 8,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 16,
            allowTouchMove: false,
          },
        },
        on: {
          afterInit: swiper => this.playVisibleVideos(swiper),
          slideChangeTransitionEnd: swiper => this.playVisibleVideos(swiper),
          resize: swiper => this.playVisibleVideos(swiper),
          slideNextTransitionStart: swiper => {
            const track = this.dataset.storyproofTrack;
            if (track !== undefined) gtag('event','storyproof_next',{event_category:track});
          },
          slidePrevTransitionStart: swiper => {
            const track = this.dataset.storyproofTrack;
            if (track !== undefined) gtag('event','storyproof_prev',{event_category:track});
          },
        },
      });
    }

    disconnectedCallback() {
      this.swiper.destroy(true, true);
    }

    playVisibleVideos(swiper) {
      swiper.slides.forEach(slideEl => {
        const video = slideEl.querySelector('video');
        if (video === null) return;
        if (slideEl.classList.contains('swiper-slide-visible') && !window.sunski.prefersReducedMotion.matches) video.play();
        else video.pause();
      });
    }
  }

  customElements.define('sk-storyproof', Storyproof);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ticker"] && !Shopify.designMode) return;
  try {
    class Ticker extends HTMLElement {
    connectedCallback() {
      const contentEl = this.querySelector('.ticker-content');
      contentEl.style.removeProperty('visibility');

      this.originalContent = contentEl.cloneNode(true);

      this.resizeObserver = new ResizeObserver(() => this.fill());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }

    fill() {
      const tickerWidth = this.offsetWidth;

      this.querySelectorAll('.ticker-content').forEach(el => el.remove());

      const first = this.originalContent.cloneNode(true);
      this.appendChild(first);
      const contentWidth = first.offsetWidth;
      if (contentWidth === 0) return;

      const needed = Math.ceil((tickerWidth * 2) / contentWidth) + 1;

      for (let i = 1; i < needed; i++) {
        const clone = this.originalContent.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this.appendChild(clone);
      }

      this.style.setProperty('--ticker-content-width', `${contentWidth}px`);
      this.style.setProperty('--ticker-duration', `${contentWidth * 25}ms`);
    }
  }

  customElements.define('sk-ticker', Ticker);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["youtube"] && !Shopify.designMode) return;
  try {
    const youtubeApiReady = new Promise(resolve => {
    if (window.YT?.loaded) {
      resolve();
      return;
    }

    const previous = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      previous?.();
      resolve();
    };

    if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    }
  });

  class Youtube extends HTMLElement {
    connectedCallback() {
      this.eventController = new AbortController();
      this.dialogEl = this.querySelector('.youtube-dialog');
      this.containerEl = this.querySelector('.youtube-container');
      this.playerEl = this.querySelector('.youtube-player');
      this.closeEls = this.querySelectorAll('.youtube-close');
      this.buttonEls = this.querySelectorAll('.ng-button');

      this.dialogEl.addEventListener('close',e => {
        this.reset();
      }, {signal: this.eventController.signal});

      this.containerEl.addEventListener('click',e => {
        e.stopPropagation();
      }, {signal: this.eventController.signal});

      this.closeEls.forEach(closeEl => {
        closeEl.addEventListener('click',e => {
          this.dialogEl.close();
        }, {signal: this.eventController.signal});
      });

      document.querySelectorAll(`.youtube-open[data-youtube-id="${this.dataset.youtubeId}"]`).forEach(openEl => {
        openEl.addEventListener('click',e => {
          this.open();
        }, {signal: this.eventController.signal});
      });

      youtubeApiReady.then(() => {
        if (!this.isConnected) return;

        new window.YT.Player(this.playerEl, {
          events: { onReady: e => { this.player = e.target; } }
        });
      });
    }

    disconnectedCallback() {
      this.player?.destroy();
      this.player = null;
      this.eventController.abort();
    }

    open() {
      this.buttonEls.forEach(buttonEl => { buttonEl.button?.reset(); });
      document.querySelectorAll(`.youtube-pause[data-youtube-id="${this.dataset.youtubeId}"]`).forEach(pauseEl => { pauseEl.pause(); });
      this.dialogEl.showModal();
      this.player?.playVideo();
    }

    reset() {
      if (!window.sunski.prefersReducedMotion.matches) {
        document.querySelectorAll(`.youtube-pause[data-youtube-id="${this.dataset.youtubeId}"]`).forEach(pauseEl => { pauseEl.play(); });
      }
      this.player?.pauseVideo();
    }
  }

  customElements.define('sk-youtube', Youtube);
  } catch(e) { console.error(e); }
})();

})();
